import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=281c0c30&scoped=true&"
import script from "./CategoryTabs.vue?vue&type=script&lang=js&"
export * from "./CategoryTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c0c30",
  null
  
)

export default component.exports